/**
 * Single source of truth for routes that DO NOT require a logged-in user.
 *
 * Used by:
 *   - <PublicOrAuthGate> in App.js (decides whether to redirect to /login)
 *   - handleAuthFailure() in utils/axiosConfig.js (decides whether a 401 from
 *     a background API call should force a full-page bounce to /login)
 *
 * Adding a new public route? Add the path here ONCE. Don't duplicate the
 * list in App.js or axiosConfig.js — that's how the /register flash-redirect
 * bug happened.
 *
 * Rules:
 *   - Paths ending in '/' match by prefix (e.g. '/drawing-room/' matches '/drawing-room/abc').
 *   - Paths without trailing slash match exactly OR as a path segment prefix
 *     (e.g. '/login' matches '/login' and '/login/something' but not '/loginx').
 */
export const PUBLIC_PATH_PREFIXES = [
  '/login',
  '/register',
  '/forgot-password',
  '/reset-password',
  '/super-admin',
  '/join',
  '/drawing-room/',
  '/site-office/',
  // DP275-P4a — the scanned field sheet: the code IS the credential.
  '/f/',
  // DP276-M1 — the scanned material tag: the code on the carton is the key.
  '/m/',
  // AS-2d — the assembly a drawing block's QR opens: the 10-char key is it.
  '/a/',
  // RS-3a — a palette given to a contractor: the code in the link is it.
  '/p/',
  // RS-8 — a vendor's answer page: the code in the link is it.
  '/q/',
  // CS-2 — a shared Spec Sheet: the token in the link is the credential.
  '/s/',
  // CS-3b — a shared Spec Book: the token in the link is the credential.
  '/b/',
  // SC-5 — a shared Plan Review report: the token in the link is the credential.
  '/r/',
  '/contractor-portal',
  '/portfolio/',
  '/photo-shares/',
  '/memo/',
  '/agreement/',
  '/legal/',
  '/work-tables/shared/',
];

export function isPublicPath(pathname) {
  return PUBLIC_PATH_PREFIXES.some((p) =>
    p.endsWith('/') ? pathname.startsWith(p) : pathname === p || pathname.startsWith(p + '/')
  );
}
